 
    
    <!-- ================================== HOD Identified Calendar ================================= -->
       <div class="cardBox mb-20">
        <ion-row class="ion-align-items-center ion-justify-content-between ml-10 pt-20">
          <!--  Year  Dropdown -->
             <ion-col class="d-flex" size="12" size-md="9">
               <ion-row class="w-100">
                 <!-- Select Year -->
                 <ion-col size="12" size-sm="6" size-md="4">
                   <mat-form-field class="w-100 mat-height40 mat-input-style">
                     <mat-select placeholder="Select Year" [(ngModel)]="selectedYearForCompetency"
                       (selectionChange)="getYearSetupForReimbursement(selectedYearForCompetency)">
                       <mat-option [value]="item.year" *ngFor="let item of pmsYears">
                         {{ sharedService.transformYearToFyFormat(item.year) }}
                       </mat-option>
                     </mat-select>
                   </mat-form-field>
                 </ion-col>
           
                 <!-- Select Program  -->
                 <ion-col size="12" size-sm="6" size-md="4">
                    <ng-multiselect-dropdown class="w-100 mat mat-height40 mat-input-style"
                  [placeholder]="'Select Department'"
                  [settings]="dropdownSettings"
                  [data]="getDepartmentsList"      
                  (onSelect)="onDepartmentSelect()"
                  (onDeSelect)="onDepartmentDeSelect()"
                  (onSelectAll)="onDepartmentAllSelect()"
                  (onDeSelectAll)="onDepartmentAllDeSelect()">
                </ng-multiselect-dropdown>
                 </ion-col>
               </ion-row>
             </ion-col>
           
             <!--  Add Programme Button -->
             <ion-col size="12" size-md="3"  style="text-align: right;">
                <button type="button" class="add_btn fs-14 mr-15"
          
            [style.background-color]="buttonColorName" (click)="onClickAddNewProgramPopup()">
            + Add Programme</button>
             </ion-col>
           </ion-row>
           

        <hr style="border: none; height: 1px; background-color: #cccccc8f; margin: 22px 0;" />

     
        <ion-row class="ion-align-items-center ion-justify-content-between ml-20">
          <ion-col size="12" size-lg="9">
            <ion-row class="ion-align-items-center">
              <!-- Search -->
              <ion-col size="12" size-sm="4" >
                <mat-form-field class="mat-height40 mat-input-style w-100">
                  <mat-icon matPrefix>search</mat-icon>
                  <input matInput type="search" placeholder="Search" [(ngModel)]="searchTerm" (input)="filterEmployees()">
                </mat-form-field>
              </ion-col>
            </ion-row>
          </ion-col>
        
          <ion-col size="12" size-lg="3" >
            <div class="d-flex justify-content-end align-items-center" style="gap: 10px;">    
              <label>
                <ion-label class="fs-14 font_regular pr-10 black_color ml-10">Show</ion-label>
                <mat-form-field class="w70px mat-height40 mat-input-style">
                  <mat-select placeholder="Select" (selectionChange)="DislaySelectedRecord($event)">
                    <mat-option [value]="2">2</mat-option>
                    <mat-option [value]="25">25</mat-option>
                    <mat-option [value]="50">50</mat-option>
                    <mat-option [value]="75">75</mat-option>
                    <mat-option [value]="100">100</mat-option>
                  </mat-select>
                </mat-form-field>
                <ion-label class="fs-14 font_regular pl-10 black_color">entries</ion-label>
              </label>
              <!-- Download Icon -->
              <span class="icon-download fs-20 material-icons" style="cursor: pointer;" (click)="downloadEmployeeList()">download</span>
            </div>
          </ion-col>
        
        </ion-row>
        
        
        <div class="p-10">
          <ion-row>
            <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12">
               
             <div class="table-container">
              <table class="custom-table rounded-header">
                 <thead>
                  <tr>
                    
                     <th *ngFor="let item of tableHeaders"
                      class="fs-14 font_bold cl-black">
                      <div class=" verticle-center justify-content-space-between icon-style">
                        {{ item?.label }}
                      </div>
                     </th>
                  </tr>
                </thead>
                  <tbody class="bg-white">    
                      <tr *ngFor="let program of getHodCalendor">
                        <td>{{ program.hodName }}</td>
                         <td>{{ program.hodDept }}</td>
                         <td>{{ program.hodCode }}</td>
                         <td>{{ program.programmeTitle }}</td>
                         <td>{{ program.startDate }}</td>
                         <td>{{ program.endDate }}</td>
                         <td>{{ program.programmeDetails}}</td>
                         <td>{{ program.programmeBrochureUrl}}</td>
                         <td>{{ program.status }}</td>
                         <td>{{ program.comment }}</td>
                      <td>
                        <img class="mr-5 cp imgdelete" title="Edit" src="././assets/icon/edit.png"
                        (click)="editProgram(program)" width="25px" >
    
                        <span class="material-icons fs-20 red cp"  (click)="deleteProgram()"
                         >delete</span>
                      </td>
                    </tr>
                  </tbody>
              </table>
            </div>
            
              
              
            </ion-col>
          </ion-row>
        </div>
      
      
      </div>
      
      



  